import { Button } from '@mui/material'

import { Fragment, useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { DISABLED, SELECTED, DEFAULT } from '@services/theme'

export const Link = (props) => {
    const url = useLocation()
    const pathname = url.pathname
    const navigate = useNavigate()

    const [mode, setMode] = useState(DEFAULT)

    useEffect(() => {
        if (props.disabled) setMode(DISABLED)
    }, [])

    useEffect(() => {
        if (props.disabled) return
        // setMode((pathname?.includes(props.path)) ? SELECTED : DEFAULT)
        setMode((pathname === props.path) ? SELECTED : DEFAULT)
    }, [pathname])

    const handleNavigate = () => {
        if (props.disabled) return
        navigate(props.path)
    }

    return (
        <Fragment>
            {(props.target)
                ? (
                    <a href={props.path} target={`_${props.target}`}>
                        <Button
                            variant={'header'}
                            disabled={props.disabled}
                        >
                            <span className={mode}>{props.label}</span>
                        </Button>
                    </a>
                )
                : (
                    <Button
                        onClick={handleNavigate}
                        variant={'header'}
                        disabled={props.disabled}
                    >
                        <span className={mode}>{props.label}</span>
                    </Button>
                )
            }
        </Fragment>
    )
}

export default Link